import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import {Mutation} from 'react-apollo';
import {WithCheckLoggedIn} from './WithCheckLoggedIn';
import {ALVA_TOKEN_KEY} from './constants';
import {clearAuthTokens} from './utils';


export const LOGIN = gql`
mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    ok
    errorMessage
    token
  }
}
`;


export class WithLogin extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired
    };

    login = (doLogin, email, password, refetchLoginStatus) => {
        return doLogin({variables: {email, password}})
            .then(({data: {login: {ok, token}}}) => {
                if (ok) {
                    this.setUserAuthToken(token);
                    refetchLoginStatus();
                }
                else {
                    clearAuthTokens();
                }
            });
    };

    setUserAuthToken = (token) => {
        localStorage.setItem(ALVA_TOKEN_KEY, token);
    };

    render() {
        return (
            <WithCheckLoggedIn>
                {({refetchLoginStatus}) =>
                    <Mutation mutation={LOGIN}>
                        {(doLogin, loginResult) => this.props.children((email, password) => this.login(doLogin, email, password, refetchLoginStatus), loginResult)}
                    </Mutation>}
            </WithCheckLoggedIn>
        );
    }
}
